// @flow

import type {
  AssetOperationsById,
} from 'fc-operator-asset/types'

// Constants
import {
  TREE,
  OPERATIONS_BRANCH,
} from '../constants'

import traverse from 'fc-utils/traverse'

type AssetOperationsSelector = (state: Object) => AssetOperationsById

export default (traverse([TREE, OPERATIONS_BRANCH]): AssetOperationsSelector)
